export default {"src":"/_next/static/media/Alejandro-Cartagena1.05acda3d.JPG","height":502,"width":334};